import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetExamRequestReports,
	GetExamRequestReportsModel,
	GetExamRequestReportsParams,
} from 'domain/usecases/private/exam-results/get-exam-request-reports';

export class RemoteGetExamRequestReports implements GetExamRequestReports {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamRequestReportsModel>,
	) {}

	async get({
		signal,
		...params
	}: GetExamRequestReportsParams): Promise<GetExamRequestReportsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
